import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { actionCreators as modelActionCreators } from '../../store/Model.ts'
import * as metaUtils from '../../utils/metaUtils'
import { applyConditions } from '../../utils/dcmUtils'
import { getMeta } from '../../utils/metaUtils'
import { actionCreators as GlobalStoreCreator } from "../../store/General"
import './CloneDialog.scss'
import { actionCreators } from '../../store/Config.ts'
import { active } from 'd3-transition'
import { filter } from 'lodash'
import { json } from 'd3'


export const CloneDialog = (props) => {

    const studyId = useSelector(state => state.study?.uid)
    const auth = useSelector(state => state.auth)    
    const model = useSelector(state => state.model)
    const selectionTypes = useSelector(state => state.study?.selectionTypes)
    const selectionType = props?.settings?.selectionName
    const activeConfig = props?.settings?.activeModel
    const atts = model?.[activeConfig]?.config?.productDef?.atts
    const [ meta, setMeta ] = useState(null)
    const [ metaLookups, setMetaLookups ] = useState(null)
    const dispatch = useDispatch()

    const [prodUidToClone, setProdUidToClone] = useState(null)
    const [fuelTypeToClone, setFuelTypeToClone] = useState(null)
    const [cloneProdName, setCloneProdName] = useState('')
    const [products, setProducts] = useState([])
    const [loadingItems, setLoadingItems] = useState(false)


    useEffect(() => {
        window.cloneDialog = this

    }, []) 


    useEffect(() => {
        // console.log('items.length useEffect')

        if (products?.length > 0) {
            setProdUidToClone(products[0].uid || products[0].id)
            setFuelTypeToClone(1) //default
        }
    }, [products])


    useEffect(() => {

        const getSelectionType = async () => {

            const metaKey = selectionTypes?.[selectionType]?.meta
            if (!metaKey) return

            const metaKeys = [metaKey]//, ...autoSelect?.map(e => e.meta)]
            setLoadingItems(true)
            try {
                let metaTable = await metaUtils.getMetas(studyId, auth, metaKeys)                
                setProducts(metaTable?.[metaKey]) //table with selection data in meta
               
            }
            catch (err) {
                console.error(err)
            }
            setLoadingItems(false)

        }

        getSelectionType()

    }, [selectionType])


    // Ensure cloned items are only added once
    useEffect(() => {
        const clonedProds = model?.[activeConfig]?.config?.play.filter(f => f.isClone) || []

        clonedProds.forEach(cl => {
            const prod_cloned_from = products.find(f => f.uid === cl.cloneOf)
            if (prod_cloned_from) {
                const newProd = {
                    ...prod_cloned_from,
                    uid: cl.uid,
                    label: cl.label,
                    image: 'clone.png'
                }
               
            }
        })
    },)
    
    useEffect(() => {
        const fetchMeta = async () => {
            let m = await getMeta(studyId, auth, model?.[activeConfig]?.modelInfo.attConditionsTable)
            if (m) {
                setMeta(m)
            }
            
            if (cfgModel?.modelInfo.attConditionsLookups?.length > 0) {
                let lookups = await getMeta(studyId, auth, model?.[activeConfig]?.modelInfo.attConditionsLookups)
                
                if (lookups) {
                    setMetaLookups(lookups)
                }
            }
          
        }

        // Call the async function
        fetchMeta()
    }, [activeConfig])


    const cloneButton = async () => {

        if (prodUidToClone && cloneProdName && fuelTypeToClone) {

            //prod based on fuel type
            let ft = parseInt(fuelTypeToClone, 10)

            let prod_cloned = model?.[activeConfig]?.config.play.find(f => f.uid === prodUidToClone)
            prod_cloned = JSON.parse(JSON.stringify(prod_cloned))
            prod_cloned.fuel = ft

            let filteredAtts = await applyConditions(prod_cloned, atts, meta?.rules, metaLookups)
            filteredAtts = filteredAtts?.filter(f => !f.readOnly)

            // console.log('filteredatts', filteredAtts)

            prod_cloned = {
				...prod_cloned,
				...Object.fromEntries(
                    atts?.map(att => {
                        // console.log('att', att.name)
                        // console.log('prod_cloned.hasOwnProperty(key)', prod_cloned.hasOwnProperty(att.name))
                        // console.log('prod_cloned[key]', prod_cloned[att.name])
						return filteredAtts?.find( f => f.name === att.name)
							? [att.name, prod_cloned[att.name] === 0 ? 1 : prod_cloned[att.name]]
							: [att.name, 0]
					})
                ),
                brandmodel: prod_cloned?.['brandmodel'],
				fuel: ft,
                available: 1,
                label: cloneProdName
			}
            
            // console.log('filteredAtts!!!!!!!!!!!!', filteredAtts)
            // console.log('prod_cloned after apply conditions!!!!!!!!!!!!', prod_cloned)
  
            //need to add product for each years models
            const years = ['2024', '2025', '2026']
            const yearMatch = activeConfig.match(/\d{4}/)
            const active_year = yearMatch ? yearMatch[0] : null
            
            years.forEach(async (yr) => {
                let new_activeConfig = activeConfig.replace(/\d{4}/, yr)
                // console.log('new_activeConfig', new_activeConfig)
                prod_cloned = {
                    ...prod_cloned,
                    available: yr === active_year || yr > active_year ? 1 : 0
                }
                await dispatch(modelActionCreators.cloneProduct(new_activeConfig, prod_cloned))
            })

            // console.log('setting forecast neeeded!')
            dispatch(GlobalStoreCreator.setGlobalStore('forecast_needed', true)) 
            
              if (props.onBtnClick) {
                props.onBtnClick()
            }
            
        } else {
            console.log(
                'Please select a product to clone and provide a new product name.'
            )
        }
    }

    const closeDialog = () => {
        window.topBar.hideMenu()
    }

    const fuelatt = atts.find(a => a.name === 'fuel')//get fueltype

    return (
        <div className='prod-clone-dialog'>
             <button className='btn close-btn' onClick={closeDialog}>
                <i className='fas fa-times-circle'></i>
            </button>
            <div className='title'>Add a Product</div>
            <div className='subtitle'>Create a new product to configure in your product set</div>
            <div className='sel-container'>
                <div className='oneRow'>
                    <label>New Product Name</label>
                    <input
                        id='prod-to-clone'
                        type='text'                
                        onChange={ev => setCloneProdName(ev.target.value)}
                    />
                </div>
                <div className='oneRow'>
                    <label>Fuel Type</label>
                    {
                        fuelatt ?
                            <select id='fuel-selector' onChange={ev => setFuelTypeToClone(ev.target.value)} >
                                {fuelatt?.levels?.map(lev => (
                                    <option
                                        key={lev?.value}
                                        value={lev?.value}
                                    >
                                        {lev?.label}
                                    </option>
                                ))}
                            </select>
                            : null
                        }
                </div>
                <div className='oneRow'>
                    <label>Product to Copy</label>
                    <select id='clone-selector' onChange={ev => setProdUidToClone(ev.target.value)} >
                        {products?.map(option => (
                            <option
                                key={option?.uid || option?.id}
                                value={option?.uid || option?.id}
                            >
                                {option?.label}
                            </option>
                        ))}
                    </select>
                </div>
                <div>
                    <button
                        id='clone-btn'
                        className='btn clone-btn'
                        style={{ width: 50, height: 23, padding: 2 }}
                        onClick={cloneButton}
                    >
                        Add
                    </button>
                </div>
            </div>
        </div>
    )
}